import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const nistNvd = defineConnector({
  identifier: "nistNvd",
  name: "NIST NVD",
  tagLine: "National Vulnerability Database",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://services.nvd.nist.gov/rest/json"),
  auth: headerAuth([
    { name: "apiKey", value: { from: "secret", field: "apiKey" } },
  ]),
  steps: [
    {
      title: "Set up NIST NVD",
      items: [
        {
          kind: "markdown",
          content:
            "Request and activate an API key through the [NVD request form](https://nvd.nist.gov/developers/request-an-api-key), then enter it below. The key enables a higher request rate. See [API setup](https://nvd.nist.gov/developers/start-here).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://services.nvd.nist.gov/rest/json",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the documented NVD service host at https://services.nvd.nist.gov. The API documentation does not identify regional hosts; use the documented API path prefixes such as /rest/json/cves/2.0 and /rest/json/cpes/2.0.",
        },
        {
          kind: "input",
          label: "NVD API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "Request an NVD API key through the official request form by providing your organization name, email address, and organization type. Activate the key through the single-use email link and save it because NVD does not display it again.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://services.nvd.nist.gov/rest/json")
          .trim()
          .replace(/\/+$/, "") + "/cves/2.0?cveId=CVE-2020-29574",
      ...{ method: "GET" },
    }),
  },
});
